import { z } from "zod"
import { createFilterBySchema } from "../../shared/filter_dtos"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"
import { createSortSchema } from "../../shared/sort_dtos"

export const BackofficeScheduledReportsSortFields = [
  "id",
  "alias",
  "frequency",
  "createdAt",
  "updatedAt",
] as const

export type BackofficeScheduledReportsSortFieldsEnum =
  (typeof BackofficeScheduledReportsSortFields)[number]
export const BackofficeScheduledReportsSortSchema = createSortSchema(
  BackofficeScheduledReportsSortFields,
  "id",
  "asc",
)

export const BackofficeScheduledReportsFilterBySchema = createFilterBySchema([
  {
    key: "alias",
    value: z.string().optional(),
  },
  {
    key: "isActive",
    value: z
      .union([z.literal("true"), z.literal("false"), z.boolean()])
      .transform((val) => (typeof val === "boolean" ? val : val === "true"))
      .optional(),
  },
])

export const GetBackofficeScheduledReportsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape)
    .extend(BackofficeScheduledReportsSortSchema.shape)
    .extend(BackofficeScheduledReportsFilterBySchema.shape).shape,
})

export const GetBackofficeScheduledReportsParamsSchema = z.object({
  id: z.string().transform(BigInt),
})

export const UpsertBackofficeScheduledReportSchema = z.object({
  alias: z.string(),
  frequency: z.string(),
  isActive: z.boolean().optional(),
  spreadsheetId: z.string(),
  cell: z.string(),
  query: z.string(),
  useFloatComma: z.boolean().optional(),
})
